import React from "react";

// Exact circle geometry pulled from Home_varient_17.svg (viewBox 0 0 1920 972)
const BackgroundDecor = () => {
  return (
    <svg
      className="bg-decor-svg"
      viewBox="0 0 1920 972"
      preserveAspectRatio="xMaxYMin slice"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* top-right cluster */}
      <circle
        opacity="0.16"
        cx="1637.12"
        cy="269.947"
        r="868.022"
        stroke="#4D6683"
        strokeWidth="2"
        fill="none"
      />
      <circle
        opacity="0.2"
        cx="1595.77"
        cy="270.673"
        r="1002.22"
        stroke="#117FEA"
        strokeWidth="2"
        strokeDasharray="16 16"
        fill="none"
      />
      <circle cx="1664.69" cy="269.947" r="719.591" fill="#F4F7FA" />

      {/* bottom-left cluster */}
      <circle
        opacity="0.078"
        cx="146.5"
        cy="973.5"
        r="122.5"
        stroke="#117FEA"
        strokeWidth="2"
        strokeDasharray="16 16"
        fill="none"
      />
      <circle cx="147" cy="974" r="82" fill="#F4F7FA" fillOpacity="0.64" />
    </svg>
  );
};

export default BackgroundDecor;